import React from 'react';
import Chart from './Chart';
import translations from '../../translation'; // Importing translations file

const StatusDistribution = ({ content, language }) => {
  const translate = (key) => translations[language]?.[key] || key;

  if (!content) {
    return null;
  }

  return (
    <div className="bg-white shadow rounded-lg">
      <div className="px-4 py-5 sm:px-6">
        <h3 className="text-lg leading-6 font-medium text-gray-900">
          {translate('statusDistributionTitle')}
        </h3>
      </div>
      <div className="px-4 pb-5">
        <Chart content={content} language={language}/>
      </div>
    </div>
  );
};

export default StatusDistribution;
